import { createRouter, createWebHistory } from 'vue-router'
import { useMainStore } from '@/store'  // 你需要用 pinia 管理 token，或改成你自己的取 token 逻辑
import { showNotify } from 'vant';
import { i18n } from '@/i18n'; // 你的 i18n 实例
import home from "@/views/home/index.vue"
import BullMarketBrokers from "@/views/BullMarketBrokers/index.vue"
import success from "@/views/success/index.vue"

const routes = [
  {
    path: '/',
    component: home,
    name: "home",
    meta: {
      title: '首页',
      keepAlive: false,
      requiresAuth: false, //登录权限
      preload: true
    }
  },{
    path: '/BullMarketBrokers',
    component: BullMarketBrokers,
    name: "BullMarketBrokers",
    meta: {
      title: '开户',
      keepAlive: false,
      requiresAuth: false, //登录权限
      preload: true
    }
  },{
    path: '/success',
    component: success,
    name: "success",
    meta: {
      title: '开户成功',
      keepAlive: false,
      requiresAuth: false, //登录权限
      preload: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;  // 返回保存的滚动位置
    }
    return { top: 0 };  // 默认情况下跳转时滚动到顶部
  }
})

// router.beforeEach((to, from, next) => {
//   const mainStore = useMainStore()
//   // console.log(to);

//   if (to.path != '/' && to.path != '/register') {
//     if (to.meta.requiresAuth && !mainStore.token) {
//       const t = i18n.global.t; // 直接使用 i18n 实例的 t
//       showNotify({ type: 'warning', message: t('newRouter.a1') })
//       return next('/') // 跳转登录页
//     }
//   }

//   next()
// })

export default router
